import { Radio, RadioGroupProps } from 'antd';
import styles from './index.module.scss';

export const CommonRadioButton = (props: RadioGroupProps) => {
  return (
    <Radio.Group
      {...props}
      className={`${styles.radioGroup} ${props.className}`}
    />
  );
};
